var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 8.00001C14.4001 9.69739 13.7258 11.3253 12.5256 12.5255C11.3253 13.7257 9.69748 14.4 8.0001 14.4C6.30271 14.4 4.67485 13.7257 3.47461 12.5255C2.27438 11.3253 1.6001 9.69739 1.6001 8.00001C1.6001 6.30262 2.27438 4.67476 3.47461 3.47452C4.67485 2.27429 6.30271 1.60001 8.0001 1.60001C9.69748 1.60001 11.3253 2.27429 12.5256 3.47452C13.7258 4.67476 14.4001 6.30262 14.4001 8.00001ZM5.6001 6.40001C5.6001 6.18783 5.68438 5.98435 5.83441 5.83432C5.98444 5.68429 6.18792 5.60001 6.4001 5.60001C6.61227 5.60001 6.81575 5.68429 6.96578 5.83432C7.11581 5.98435 7.2001 6.18783 7.2001 6.40001V9.60001C7.2001 9.81218 7.11581 10.0157 6.96578 10.1657C6.81575 10.3157 6.61227 10.4 6.4001 10.4C6.18792 10.4 5.98444 10.3157 5.83441 10.1657C5.68438 10.0157 5.6001 9.81218 5.6001 9.60001V6.40001ZM9.6001 5.60001C9.38792 5.60001 9.18444 5.68429 9.03441 5.83432C8.88438 5.98435 8.8001 6.18783 8.8001 6.40001V9.60001C8.8001 9.81218 8.88438 10.0157 9.03441 10.1657C9.18444 10.3157 9.38792 10.4 9.6001 10.4C9.81227 10.4 10.0158 10.3157 10.1658 10.1657C10.3158 10.0157 10.4001 9.81218 10.4001 9.60001V6.40001C10.4001 6.18783 10.3158 5.98435 10.1658 5.83432C10.0158 5.68429 9.81227 5.60001 9.6001 5.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.a494cc362d173b943be05eff606a6fa6.svg";
export { ForwardRef as ReactComponent };